import { Meta } from "@/shared/components";
import { SupportRequests } from "@/admin/features/supportRequests";

export function AssistantRequestsPage() {
  return (
    <>
      <Meta title="Обращения" />
      <SupportRequests />
    </>
  );
}
